export default "__VITE_ASSET__7f9bc57a__"